export const useMyTeamsRouteParams = (route: any, props: any = {}) => {
  const params = {
    ...(route?.params || {}),
    ...props,
  };

  return {
    isViewTeam: params?.isViewTeam,
    title: params?.title,
    coachId: params?.coachId,
    viewTeamData: params?.viewTeamData,
    getAddCoachToWatchlist: params?.addCoachToWatchlist,
    getRemoveCoachFromWatchlist: params?.removeCoachFromWatchlist,
    getViewTeams: params?.getViewTeams,
    onPress: params?.onPress,
    lastPaidRank: params?.lastPaidRank,
    highestAchievedRank: params?.highestAchievedRank,
    coachCurrentRank: params?.coachCurrentRank,
    userId: params?.userId,
  };
};
